// extracted by mini-css-extract-plugin
export default {"button":"Button_button__zvAvJ","primary":"Button_primary__F9T7Y","secondary":"Button_secondary__660v0","accent":"Button_accent__utla9"};